import { render, staticRenderFns } from "./salesContract.vue?vue&type=template&id=9b67d3d4"
import script from "./salesContract.vue?vue&type=script&lang=js"
export * from "./salesContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports